<template lang="pug">
  .alert-item(:class="alert_class")
    .alert-item--title {{alert.title}}
    .alert-item--body(v-html="alert.body")
    .alert-item--time {{alert_time}}
    .alert-item--icon.alert-item--closer(@click="$emit('click_close', alert)")
      icon-mdi(:icon="icon_close")
    .alert-item--icon.alert-item--link(@click="$emit('click_link', alert)")
      icon-mdi(:icon="icon_link")


</template>

<script>
import DateMethods from "../../mixins/DateMethods";
import IconMdi from "../icons/IconMdi";
import { mdiWindowClose } from '@mdi/js'
import { mdiArrowRight } from '@mdi/js'
// import { mdiChevronDoubleRight } from '@mdi/js'
// import { mdiOpenInNew } from '@mdi/js'

export default {
name: "alertItem",
  components: {IconMdi},
  mixins: [DateMethods],
  props: {
    alert: {
      type: Object,
      default: {
        body: 'default body'
      }
    }
  },
  data(){
    return {
      icon_close: mdiWindowClose,
      icon_link: mdiArrowRight,
    }
  },
  computed:{
    alert_time(){
      return this.formatted_date(this.alert.created_at);
    },
    alert_class(){
      let css =[]
      css.push(this.alert_type_class);
      css.push(this.alert_importance_class);
      css.push(this.alert_just_received_class);

      return css.join(' ');
    },
    alert_type_class(){
      if (this.alert.alert_type === 'message') return 'message';
      if (this.alert.alert_type === 'system') return 'system';
    },
    alert_importance_class(){
      return `alert-importance-${this.alert.importance}`
    },
    alert_just_received_class(){
      return this.alert.just_received ? 'just-received' : ''
    },
  }
}
</script>

<style scoped>
  .alert-item {
    transition: all .3s ease;
    position: relative;
    background-color: white;
    padding: 15px 45px 15px 15px;
    margin-bottom: 10px;

    border-radius: 12px;
    border-width: 1px;
    border-left-width: 4px;
    border-style: solid;
    border-color: #e1e3e6;
  }

  .alert-item.just-received {
    border-right-width: 1px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    position: relative;
    left: -350px;
  }
  .alert-item.system {
    background-color: #fffbf5;
    border-color: #ffc554;
  }

  .alert-item.alert-importance-medium{
    background-color: #fff9f5;
    border-color: #ff9654;
  }

  .alert-item.alert-importance-critical{
    background-color: #fff0ef;
    border-color: #ff4d3a;
  }

  .alert-item--title {
    color: #b1b9c1;
    text-transform: uppercase;
    font-size: 12px;
  }

  .alert-item--time {
    color: #b1b9c1;
    font-size: 12px;
  }

  .alert-item--icon {
    transition: all .2s ease;
    width: 25px;
    height: 25px;
    padding: 3px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    color: #7a6dd7;
  }

  .alert-item--icon:hover{
    background-color: #eaedf0;
  }

  .alert-item--closer {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .alert-item--link {
    position: absolute;
    top: 45px;
    right: 10px;
  }


</style>